// index.ts
var CollaborationStatus = /* @__PURE__ */ ((CollaborationStatus2) => {
  CollaborationStatus2["Collaboration"] = "COLLABORATION";
  CollaborationStatus2["CollaborationCancelled"] = "COLLABORATION_CANCELLED";
  CollaborationStatus2["NoCollaboration"] = "NO_COLLABORATION";
  CollaborationStatus2["NoCollaborationPossible"] = "NO_COLLABORATION_POSSIBLE";
  CollaborationStatus2["Pending"] = "PENDING";
  return CollaborationStatus2;
})(CollaborationStatus || {});
var EventRecurrence = /* @__PURE__ */ ((EventRecurrence2) => {
  EventRecurrence2["Daily"] = "daily";
  EventRecurrence2["Monthly"] = "monthly";
  EventRecurrence2["Weekly"] = "weekly";
  EventRecurrence2["Workdays"] = "workdays";
  EventRecurrence2["Yearly"] = "yearly";
  return EventRecurrence2;
})(EventRecurrence || {});
var GroupType = /* @__PURE__ */ ((GroupType2) => {
  GroupType2["Course"] = "course";
  GroupType2["Group"] = "group";
  return GroupType2;
})(GroupType || {});
var SortDirection = /* @__PURE__ */ ((SortDirection2) => {
  SortDirection2["Asc"] = "ASC";
  SortDirection2["Desc"] = "DESC";
  return SortDirection2;
})(SortDirection || {});
var SubmissionStatus = /* @__PURE__ */ ((SubmissionStatus2) => {
  SubmissionStatus2["Done"] = "Done";
  SubmissionStatus2["Draft"] = "Draft";
  SubmissionStatus2["Feedback"] = "Feedback";
  SubmissionStatus2["New"] = "New";
  SubmissionStatus2["Todo"] = "Todo";
  SubmissionStatus2["Updated"] = "Updated";
  return SubmissionStatus2;
})(SubmissionStatus || {});
var UserStatus = /* @__PURE__ */ ((UserStatus2) => {
  UserStatus2["Full"] = "full";
  UserStatus2["ImpersonateOnly"] = "impersonateOnly";
  UserStatus2["Invited"] = "invited";
  UserStatus2["None"] = "none";
  return UserStatus2;
})(UserStatus || {});
export {
  CollaborationStatus,
  EventRecurrence,
  GroupType,
  SortDirection,
  SubmissionStatus,
  UserStatus
};
